"use client";

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import {AlertTriangle} from "lucide-react";
import { useTranslation } from "react-i18next";
import {LocalizationKeys} from "@/lib/all-localization-keys";

interface PasswordChangeWarningDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    userEmail: string;
}

export function PasswordChangeWarningDialog({
    open,
    onOpenChange,
    onConfirm,
    userEmail,
}: PasswordChangeWarningDialogProps) {
    const { t } = useTranslation();
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <div className="flex items-center gap-2">
                        <AlertTriangle className="h-5 w-5 text-destructive"/>
                        <AlertDialogTitle>{t(LocalizationKeys.DIALOG_PASSWORD_CHANGE_TITLE)}</AlertDialogTitle>
                    </div>
                    <AlertDialogDescription className="space-y-3 pt-2">
                        <p>
                            {t(LocalizationKeys.DIALOG_PASSWORD_CHANGE_MESSAGE, { email: userEmail })}
                        </p>
                        <p className="text-xs text-muted-foreground">
                            {t(LocalizationKeys.DIALOG_PASSWORD_CHANGE_HELP)}
                        </p>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>{t(LocalizationKeys.BUTTON_CANCEL)}</AlertDialogCancel>
                    <AlertDialogAction onClick={onConfirm}>
                        {t(LocalizationKeys.BUTTON_CONTINUE)}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
